"use client";

// Customer Story — desktop sticky scroll-nav (Figma 4287:45491).
// Pills mirror the container sections. The active pill carries the grey-100
// "Scroll Indicator" gauge (Figma 4287:45493) that fills with reading progress
// through the section. (The Figma's cursor glyph was only a hover example.)

import { useActiveSection, useSectionProgress } from "./use-active-section";
import type { StoryNavItem } from "./use-active-section";

export function CustomerStorySidebarNav({
  items,
  ariaLabel,
}: {
  items: StoryNavItem[];
  ariaLabel?: string;
}) {
  const activeId = useActiveSection(items);
  const progress = useSectionProgress(activeId);

  return (
    <nav aria-label={ariaLabel} className="flex flex-col gap-3 p-3">
      {items.map((item) => {
        const active = item.id === activeId;
        return (
          <a
            key={item.id}
            href={`#${item.id}`}
            className="bg-grey-50 relative flex min-h-8 items-center overflow-hidden rounded-lg py-1.5"
          >
            {active ? (
              <span
                aria-hidden
                className="bg-grey-100 absolute inset-y-0 left-0"
                style={{ width: `${Math.max(progress * 100, 8)}%` }}
              />
            ) : null}
            <span className="text-grey-950 relative z-10 min-w-0 px-2 text-[12px] leading-[1.4] break-words">
              {item.label}
            </span>
          </a>
        );
      })}
    </nav>
  );
}
